import * as types from './ActionTypes';
import { create } from 'axios';

const ajax = create({
  contentType: 'application/json',
  baseURL: process.env.REACT_APP_CORE_USER_API_URL
});

ajax.defaults.withCredentials = true;

export const buildTree = externalKey => dispatch => {
  dispatch({
    type: types.SET_ORG_TREE,
    payload: ajax.get(`/organizations/tree/${externalKey}`).then(data => data.data.registrationTree)
  });
};





// WEBPACK FOOTER //
// ./src/actions/tree.action.js